// extracted by mini-css-extract-plugin
module.exports = {"commitCommentContainer":"style_commitCommentContainer__2dzlQ","commitLink":"style_commitLink__3z--A","commitComment":"style_commitComment__yHvOk"};